import { request } from './repository';

const url = 'file-types/';

const fieldTypeStore = {
    getFieldTypes() {
        return request.get(url);
    },
}

export default fieldTypeStore;
